export const abCampaignEvent = ({ testName, variationId, variationName }) => ({
  'Test Name': testName,
  VariationID: variationId,
  VarationName: variationName,
});
